import {split, reverse, join, compose} from 'ramda';

import { toNumber } from './evolve';

const getDate = (dateString) =>  dateString && compose( join(''), reverse, split('.'))(dateString);

const personStateMapper = (values) => {
    const { come_to_work_date, endOfTrial, whoTrudoId } = values;
    return ({
        ...values,
        whoTrudoId: whoTrudoId ? toNumber(whoTrudoId) : undefined,
        come_to_work_date: getDate(come_to_work_date),
        endOfTrial: getDate(endOfTrial),
    });
};

export default personStateMapper;
